require('./lbResolveLoader.scss');

const lbResolveLoader = angular.module('app.lbResolveLoader', []);

lbResolveLoader.component('lbResolveLoader', {
  controller: ['$rootScope', lbResolveLoaderCtrl],
  template: `
    <div ng-if="$root.showLoader">
        <div class="lbResolveLoader_mask"></div>
        <div class="lbResolveLoader">
            <div class="lbResolveLoader_container">
                <i class="button_spinner"></i>
                <span class="lbResolveLoader_text">Loading</span>
            </div>
        </div>
    </div>
  `,
});

function lbResolveLoaderCtrl($rootScope) {
  $rootScope.showLoader = true;
}

export default lbResolveLoader;



// WEBPACK FOOTER //
// ./src/components/lbResolveLoader/lbResolveLoader.js